import { invoke } from '@tauri-apps/api/core'
import { deviceHttpArgs } from './httpTransfer.js'
import { normalizeGpioConfig, serializeGpioConfig } from '../gpio/gpioPlateConfig.js'

function responseError(response, operation) {
    const detail = response?.body?.error || response?.body?.message || response?.body
    return new Error(`${operation} failed (HTTP ${response?.status ?? 'unknown'}): ${typeof detail === 'string' ? detail : JSON.stringify(detail ?? {})}`)
}

function configArgs(plate, context) {
    return { ...deviceHttpArgs(plate), context }
}

export async function loadDeviceGpioConfig(plate, invokeImpl = invoke) {
    const response = await invokeImpl('api_get_command', {
        connArgs: configArgs(plate, 'config/gpio/'),
    })
    const gpio = response?.body?.gpio ?? response?.body
    if (!response || response.status >= 400 || !gpio?.config) throw responseError(response, 'GPIO configuration load')
    return {
        config: normalizeGpioConfig(gpio),
        response,
    }
}

/**
 * Uses the firmware's existing per-module HTTP configuration API. A successful
 * HTTP response is followed by a module read-back and semantic comparison so
 * the UI never reports deployment success without firmware confirmation.
 */
export async function deployDeviceGpioConfig(plate, config, invokeImpl = invoke) {
    const payload = serializeGpioConfig(config)
    const response = await invokeImpl('api_post_command', {
        connArgs: configArgs(plate, 'config/gpio/'),
        payload,
    })
    if (!response || response.status >= 400 || !response.body) throw responseError(response, 'GPIO configuration deployment')
    const verified = await loadDeviceGpioConfig(plate, invokeImpl)
    const verifiedPayload = serializeGpioConfig(verified.config)
    if (JSON.stringify(verifiedPayload) !== JSON.stringify(payload)) {
        throw new Error('GPIO configuration deployment read-back differs from the requested configuration.')
    }
    return { payload, response, verified: verified.config }
}

